import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
export class EnemyType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PHYSICAL": return 0;
        case "FIRE": return 1;
        case "WATER": return 2;
        case "NATURE": return 3;
        case "LIGHT": return 4;
        case "DARK": return 5;
        case "FLYING": return 6;
        case "STEALTH": return 7;
        case "BOSS": return 8;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return EnemyType.fromJson(value);
  }
  static fromReact(e) {
    return EnemyType.fromJson(e);
  }
}
EnemyType.PHYSICAL = 0;
EnemyType.FIRE = 1;
EnemyType.WATER = 2;
EnemyType.NATURE = 3;
EnemyType.LIGHT = 4;
EnemyType.DARK = 5;
EnemyType.FLYING = 6;
EnemyType.STEALTH = 7;
EnemyType.BOSS = 8;
EnemyType.default = 0;
EnemyType.values = {
  PHYSICAL: 0,
  FIRE: 1,
  WATER: 2,
  NATURE: 3,
  LIGHT: 4,
  DARK: 5,
  FLYING: 6,
  STEALTH: 7,
  BOSS: 8,
};
EnemyType.names = {
  0: "PHYSICAL",
  1: "FIRE",
  2: "WATER",
  3: "NATURE",
  4: "LIGHT",
  5: "DARK",
  6: "FLYING",
  7: "STEALTH",
  8: "BOSS",
};
